<div class="mat-typography mat-body mat-app-background">

  @for (benefit of benefitGroup.benefits; track benefit) {
    <ul>
      <li>
        <div class="document-name-container">
          <span class="material-symbols-outlined">picture_as_pdf</span>
          <div class="document-title">
            {{benefit.name}}
          </div>
        </div>
      </li>
    </ul>
  }
</div>
